import { render, staticRenderFns } from "./tsm-leaderboard.vue?vue&type=template&id=ba3b0212&scoped=true"
import script from "./tsm-leaderboard.vue?vue&type=script&lang=js"
export * from "./tsm-leaderboard.vue?vue&type=script&lang=js"
import style0 from "./tsm-leaderboard.vue?vue&type=style&index=0&id=ba3b0212&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba3b0212",
  null
  
)

export default component.exports